import { Route } from '@angular/router';

import { applicationRouteNames } from '../../app/application-route-names';
import { MpsRoleHelper } from '../../app/helpers/mps-role.helper';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsIRoutesRules } from '../interfaces/mps-routes-rules.interface';

export class MpsPermissionHelper {
  // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
  // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
  // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
  // Use property 'allowedRoles' to give access only to user having those specifics roles :
  // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

  static readonly routesRules: MpsIRoutesRules[] = [
    { routepath: applicationRouteNames.home },
    { routepath: applicationRouteNames.administration, allowedRoles: [MpsRoleHelper.ADMIN] },
    { routepath: applicationRouteNames.users, allowedRoles: [MpsRoleHelper.ADMIN] },
    { routepath: applicationRouteNames.lokalise, allowedRoles: [MpsRoleHelper.ADMIN] },
  ];

  static readonly routesRulesForHPC: MpsIRoutesRules[] = [
    { routepath: applicationRouteNames.administration, allowedRoles: [MpsRoleHelper.ADMIN] },
    { routepath: applicationRouteNames.hpc, allowedRoles: [MpsRoleHelper.HPG, MpsRoleHelper.CD, MpsRoleHelper.N17] },
    { routepath: applicationRouteNames.users, allowedRoles: [MpsRoleHelper.HPG, MpsRoleHelper.CD, MpsRoleHelper.N17] },
    { routepath: applicationRouteNames.lunch, allowedRoles: [MpsRoleHelper.HPG] },
    { routepath: applicationRouteNames.dashboard, allowedRoles: [MpsRoleHelper.HPG] },
    { routepath: applicationRouteNames.lokalise, allowedRoles: [MpsRoleHelper.ADMIN] },
  ];

  static canUserActivate(user: MpsUser, route: Route) {
    const routeRule = this.routesRules.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyRole(user, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static canUserActivateForHpc(user: MpsUser, route: Route, profile: string) {
    const routeRule = this.routesRulesForHPC.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotProfile(profile, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyProfile(profile, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static isAdmin(user: MpsUser): boolean {
    return user.role !== null && user.isAdmin();
  }

  static hasAnyRole(user: MpsUser, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: MpsUser, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }

  static hasAnyProfile(profile: string, profilesList: string[]) {
    return profile && profilesList.includes(profile.toUpperCase());
  }

  static hasNotProfile(profile: string, profilesList: string[]) {
    return profile && !profilesList.includes(profile.toUpperCase());
  }
}
